import { gql } from "@apollo/client";

const GET_ADJUSTMENT_CATEGORIES = gql`
  query GetAdjustmentCategories {
    adjustmentCategories {
      count
      items {
          id
          categoryName
          categoryKey
      }
    }
  }
`;

export default GET_ADJUSTMENT_CATEGORIES;

